import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';

export default function SearchEnginesV116({ config, onChange, disabled, t }) {
  const [added, setAdded] = useState([]);
  const selected = config.search_engines_v116 || [];
  const names = [...new Set(['google', 'bing', 'brave', 'duckduckgo', ...selected, ...added])];
  return (
    <Form.Dropdown
      label={t('channel.edit.search_v115.engines')}
      aria-label={t('channel.edit.search_v115.engines')}
      placeholder={t('channel.edit.search_v115.engines_default')}
      name='search_engines_v116'
      fluid multiple selection search allowAdditions
      disabled={disabled}
      value={selected}
      options={names.map(value => ({ key: value, value, text: value }))}
      onAddItem={(_, { value }) => setAdded(current => [...new Set([...current, value])])}
      onChange={(event, { value }) => onChange(event, { name: 'search_engines_v116', value })}
    />
  );
}
